browserDetectRun.$inject = ['$rootElement'];
export function browserDetectRun($rootElement) {

  // Add classes that allow subtle css adjustements for iDevices
  if (RegExp('iPhone').test(navigator.userAgent)) {
    $rootElement.addClass('ios');
    $rootElement.addClass('iphone');
  }
  if (RegExp('iPad').test(navigator.userAgent)) {
    $rootElement.addClass('ios');
    $rootElement.addClass('ipad');
  }

  // Add a class that allows less subtle css adjustements for IE11
  if (RegExp('MSIE|Trident').test(navigator.userAgent)) {
    $rootElement.addClass('msie');
  }

}